import { InputWidgetsModule } from './input-widgets/input-widgets.module';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseSharedModule } from '@fuse/shared.module';
import { DateModule } from '../content/misc/date.module';
import { CardWidgetsModule } from './card-widgets/card-widgets.module';
import { ChartWidgetsModule } from './chart-widgets/chart-widgets.module';
import { CountWidgetsModule } from './count-widgets/count-widgets.module';
import { NgModule } from '@angular/core';
import { LabelWidgetsModule } from './label-widgets/label-widgets.module';
import { ListWidgetsModule } from './list-widgets/list-widgets.module';
import { NoteWidgetsModule } from './note-widgets/note-widgets.module';
import { TaskWidgetsModule } from './task-widgets/task-widgets.module';
import { SearchWidgetModule } from './search-widget/search-widget.module';
import { WidgetService } from './widget.service';
import { UserSelectionWidgetModule } from './user-selection-widget/user-selection-widget.module';
import { RouterModule } from '@angular/router';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ReferralCommentsWidgetModule } from './referral-comments-widget/referral-comments-widget.module';
import { GridsterModule } from 'angular-gridster2';

@NgModule({
    declarations: [

    ],
    imports: [
        RouterModule,
        CommonModule,        
        ChartWidgetsModule,
        SearchWidgetModule,
        FuseSharedModule,
        MatMenuModule,
        MatIconModule,
        MatFormFieldModule,
        InputWidgetsModule,
        CountWidgetsModule,
        ListWidgetsModule,
        LabelWidgetsModule,
        CardWidgetsModule,
        NoteWidgetsModule,
        DateModule,
        TaskWidgetsModule,
        UserSelectionWidgetModule,
        ReferralCommentsWidgetModule,
        PhoenixDirectivesModule,
        GridsterModule,
    ],
    exports: [
    ],
    providers: [
        WidgetService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
    ],
})
export class WidgetModule { }
